import * as Sentry from "@sentry/react";

const captureException = (error, options = {}) => {
  const { tags = {}, extra = {}, contexts = {} } = options;

  Sentry.withScope((scope) => {
    Object.entries(tags).forEach(([key, value]) => {
      scope.setTag(key, value);
    });

    Object.entries(extra).forEach(([key, value]) => {
      scope.setExtra(key, value);
    });

    Object.entries(contexts).forEach(([name, contextData]) => {
      scope.setContext(name, contextData);
    });

    if (typeof beforeCapture === "function") {
      beforeCapture(scope);
    }

    Sentry.captureException(error);
  });
};

export default captureException;
